import { env } from '@cc-shopping/platform-env';

export const ALERT_POP_UP_ICON = `${env.NEXT_PUBLIC_NW_URL}cdn/cc-shopping-client/shared/icons/alert-red.svg`;
